var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.url
    ? _c("div", { staticClass: "redential" }, [
        _c(
          "div",
          {
            staticClass: "hover_wrapper",
            on: {
              mouseover: function ($event) {
                _vm.showHover = true
              },
              click: function ($event) {
                _vm.showHover = true
              },
              mouseout: function ($event) {
                _vm.showHover = false
              },
            },
          },
          [
            _c("div", { staticClass: "hover_logo" }),
            _vm._v(" "),
            _vm.showHover
              ? _c("div", { staticClass: "hover_container" }, [
                  _c("img", { attrs: { src: _vm.url } }),
                ])
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }